export default "__VITE_ASSET__5c7666d6__"